import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { convertToBrDateTime } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({

    container: {
        margin: '4px',
        width: '100%'
    },
    title: {
        fontSize: 12,
        fontWeight: 'bold'
    },
    mensageSystem: {
        margin: '2px',
        textAlign: 'left',
        backgroundColor: '#FFE194'
    },
    mensageUser: {
        margin: '2px',
        textAlign: 'right',
        backgroundColor: '#AEE2FF'
    }

});

const Occurrences = ({data}) => (
    <View style={ styles.container}>
        <Text key={'Ocorrencias'} style={styles.title}>Ocorrência:</Text>
        {data.map( dt =>
            <View style={(dt.origem === 'S') ? styles.mensageSystem : styles.mensageUser}>
                <Text key={`A${dt._id.toString()}`}>{convertToBrDateTime(dt.createdAt)}</Text>
                <Text key={`B${dt._id.toString()}`}>{dt.message}</Text>
            </View>
        )}
    </View>
);
  
export default Occurrences